import React, { useState } from "react";
import { Mail, MapPin, MessageCircle, Phone, Send } from "lucide-react";
import "../styles/Contact.css";

const Contact = () => {
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    phone: "",
    subject: "",
    message: "",
  });

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value,
    });
  };

  const handleSubmit = (e) => {
    e.preventDefault();

    console.log("Contact Form:", formData);

    alert("Thank you! Your message has been submitted.");

    setFormData({
      name: "",
      email: "",
      phone: "",
      subject: "",
      message: "",
    });
  };

  return (
    <div className="contact-page">

      {/* HERO SECTION */}
      <section className="contact-hero">
        <div className="hero-overlay"></div>

        <div className="hero-content">
        
          <h1>
            Let's Build Something
            <span> Amazing Together</span>
          </h1>

          <p>
            Have a project in mind? Tell us about it and
            let's turn your ideas into powerful digital solutions.
          </p>
        </div>

        <div className="contact-hero-icons" aria-hidden="true">
          <span><Mail /></span>
          <span><MapPin /></span>
          <span><Phone /></span>
          <span><MessageCircle /></span>
          <span><Send /></span>
        </div>
      </section>


      {/* CONTACT SECTION */}
      <section className="contact-section">

        <div className="contact-container">

          {/* LEFT SIDE */}
          <div className="contact-info">

            <p className="section-label">CONTACT TECHLYNX</p>

            <h2>
              Let's start a
              <span> conversation.</span>
            </h2>

            <p className="contact-description">
              Whether you need a website, mobile application,
              cloud solution, or custom software, our team is
              ready to help you bring your ideas to life.
            </p>


            {/* CONTACT ITEM */}
            <div className="contact-item">

              <div className="contact-icon">
                📍
              </div>

              <div>
                <h4>Our Location</h4>

                <p>
                  Hyderabad, Guntur
                </p>
              </div>

            </div>


            {/* EMAIL */}
            <div className="contact-item">

              <div className="contact-icon">
                ✉
              </div>

              <div>
                <h4>Email Us</h4>

                <p>
                  info@techlynxinnovations.com
                </p>
              </div>

            </div>


            {/* PHONE */}
            <div className="contact-item">

              <div className="contact-icon">
                ☎
              </div>

              <div>
                <h4>Call Us</h4>

                <p>
                  +91 99896 81812
                </p>
              </div>

            </div>


            {/* WORKING HOURS */}
            <div className="contact-item">

              <div className="contact-icon">
                ⏰
              </div>

              <div>
                <h4>Working Hours</h4>

                <p>
                  Monday – Friday
                  <br />
                  9:30 AM – 6:30 PM
                </p>
              </div>

            </div>

          </div>


          {/* RIGHT SIDE FORM */}
          <div className="contact-form-box">

            <div className="form-heading">

              <p className="section-label">
                WRITE TO US
              </p>

              <h2>
                Tell us about your
                <span> project.</span>
              </h2>

              <p>
                Fill out the form below and our team
                will get back to you shortly.
              </p>

            </div>


            <form onSubmit={handleSubmit}>

              <div className="form-row">

                <div className="form-group">

                  <label>Your Name</label>

                  <input
                    type="text"
                    name="name"
                    placeholder="Enter your name"
                    value={formData.name}
                    onChange={handleChange}
                    required
                  />

                </div>


                <div className="form-group">

                  <label>Email Address</label>

                  <input
                    type="email"
                    name="email"
                    placeholder="Enter your email"
                    value={formData.email}
                    onChange={handleChange}
                    required
                  />

                </div>

              </div>


              <div className="form-row">

                <div className="form-group">

                  <label>Phone Number</label>

                  <input
                    type="tel"
                    name="phone"
                    placeholder="Enter phone number"
                    value={formData.phone}
                    onChange={handleChange}
                  />

                </div>


                <div className="form-group">

                  <label>Subject</label>

                  <input
                    type="text"
                    name="subject"
                    placeholder="What can we help you with?"
                    value={formData.subject}
                    onChange={handleChange}
                    required
                  />

                </div>

              </div>


              <div className="form-group">

                <label>Your Message</label>

                <textarea
                  name="message"
                  rows="6"
                  placeholder="Tell us about your project..."
                  value={formData.message}
                  onChange={handleChange}
                  required
                ></textarea>

              </div>


              <button
                type="submit"
                className="send-button"
              >
                Send Message
                <span>→</span>
              </button>

            </form>

          </div>

        </div>

      </section>


    </div>
  );
};

export default Contact;